/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

export const backfillR2UploadsResponseDataSchema = z.object({
  scanned: z.number(),
  enqueued: z.number(),
  regenerated: z.number().optional(),
  skipped: z.number(),
  nextCursor: z.string().optional(),
});

export type IBackfillR2UploadsResponseData = z.infer<typeof backfillR2UploadsResponseDataSchema>;

export const backfillR2UploadsResponseSchema = createApiResponseSchema(
  backfillR2UploadsResponseDataSchema,
) as z.ZodSchema<IAPI<IBackfillR2UploadsResponseData>>;

export type IBackfillR2UploadsResponse = IAPI<IBackfillR2UploadsResponseData>;
